import { SymbolData } from '../types';

export const stemsData: SymbolData[] = [
  {
    id: 'jia',
    char: '甲',
    pinyin: 'Jiǎ',
    summary: '甲：阳木、第一、甲壳',
    tags: ['甲', '第一', '阳木', '甲壳'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20250823160918.png',
    coreOrigins: [
      {
        title: '核心原点 ①：第一',
        logic: '（此逻辑源于甲为“十干之首”的序位。它代表一切处于顶端、最有钱、最有权、最有名的的人事物。甲隐藏在直符之中。）',
        subItems: [
          { label: '概念', content: '（最）高贵的、有名望的、第一的、首领、包装、表演' },
          { label: '人物', content: '领导人、经理、董事长、将军、元首、名人' },
          { label: '性情', content: '威严、正直、愉快、独断、心高（皆为领导者特质）' },
          { label: '地理', content: '省会、首都、领导办公室、名人居所、机关、高大建筑物' },
          { label: '食物', content: '馐珍、美味、高档食品' },
          { label: '静物', content: '金、玉、珠宝、古董、文物（贵重之物）' },
        ],
      },
      {
        title: '核心原点 ②：阳木 → 大木',
        logic: '（此逻辑源于甲的五行属性“阳木”。它就像一棵参天大树，笔直、坚挺、充满生命力，与自然界的生长息息相关。）',
        subItems: [
          { label: '形态', content: '伟光正，直、方、高；人体形长方，筋骨强健' },
          { label: '人体', content: '头、大脑（身体的顶端）、肝、胆、筋（木所主）' },
          { label: '植物', content: '大树' },
          { label: '地理', content: '无烟烟囱、粗柱子、房梁、高亢之地' },
          { label: '色彩', content: '青色、绿色' },
        ],
      },
      {
        title: '核心原点 ③：铠甲 → 坚硬、包裹与保护',
        logic: '（此逻辑源于“甲”的字形与本意，即“铠甲、甲壳”。这是甲最独特、最关键的象意，引申为一切带有坚硬外壳、起保护作用的事物。）',
        subItems: [
          { label: '人体', content: '指甲、头发（人体的“甲”）' },
          { label: '动物', content: '穿山甲、玳瑁、龙虾、乌龟、鳖、贝类、螺类、螃蟹（所有带硬壳的动物）' },
          { label: '植物', content: '带壳的果实（花生、核桃、松子、栗子、菱角、瓜子）' },
          { label: '静物', content: '帽子、甲胄、背心、盔甲、盾牌、车船的外壳（直接的保护物）' },
          { label: '地理', content: '棺材（人生的最后一个外壳）' },
        ],
      },
    ],
    story: '一位身披坚硬铠甲（铠甲/外壳）的元首（首领），如同一棵参天大树（阳木）般，威严地站立在首都（高地）的高楼之顶，他的头脑（头/大脑）中正思考着国家大计，目光如炬，而他最爱吃的，是桌上那些带壳的坚果（带壳果实）。',
  },
  {
    id: 'yi',
    char: '乙',
    pinyin: 'Yǐ',
    summary: '乙：阴木、弯曲、女人、艺、医',
    tags: ['乙', '阴木', '弯曲', '女人', '艺', '医'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20250928101516.png',
    coreOrigins: [
      {
        title: '核心原点 ①：阴木 → 小树、草地',
        logic: '乙为阴木，对应花草灌木，性质柔弱。',
        subItems: [
          { label: '五行', content: '阴木' },
          { label: '人体', content: '肝、胆 (木在脏腑)' },
          { label: '感觉', content: '酸胀 (木之味)' },
          { label: '植物', content: '小树、草地、花园、果林、菜园 (阴木所代表的植被群落)' },
        ],
      },
      {
        title: '核心原点 ②：象形 → 弯曲柔软',
        logic: '象形法：“乙”字形如藤蔓、肠道、河流，万物蜿蜒、柔软、屈曲之象。',
        subItems: [
          { label: '概念', content: '质软、弯曲、曲折' },
          { label: '形态', content: '苗条、微驼身、骨肉松弛、瘦长脸' },
          { label: '人体', content: '肠、神经、淋巴、手、足、肩、颈、臂、腿、头发、输卵管、输精管、阴道、阴茎' },
          { label: '动物', content: '蚯蚓、蛇、海参、海肠、蚕虫、龙、鸟类(形体弯曲)' },
          { label: '植物', content: '藤蔓、柳枝、牵牛、黄瓜、爬山虎 (形态弯曲)' },
          { label: '静物', content: '管道、拐弯之物、楼梯、面条、绳索、线缆' },
        ],
      },
      {
        title: '核心原点 ③：女人 → 阴柔依附',
        logic: '角色法：乙庚合，如少女配将军，故为妻、为女。',
        subItems: [
          { label: '概念', content: '依附（抱大腿）' },
          { label: '人物', content: '女人、妻子、（女性化）' },
          { label: '性情', content: '依赖、犹豫、敏感、自私、逆来顺受 、仁慈、柔弱、仁爱、柔情、善人、柔顺' },
        ],
      },
      {
        title: '核心原点 ⑤：谐音 → 艺 (文化创造)',
        logic: '谐音法：乙 (yǐ) ≈ 医 (yī) + 艺 (yì) + 依 (yī)。一个音，贯穿三大核心功能。',
        subItems: [
          { label: '概念', content: '艺术、文化' },
          { label: '人物', content: '艺人、画师、作家（艺术家爱留长发）' },
          { label: '植物', content: '花草、水果树、龙爪槐 (观赏性、美丽)' },
          { label: '静物', content: '漂亮的雕梁画柱、美丽的艺术品、葫芦、木雕、图画、装饰性强的物品、漂亮的房间、门、窗、藤椅' },
          { label: '地理', content: '艺术馆、漂亮的建筑物' },
        ],
      },
      {
        title: '核心原点 ④：谐音 → 医 (疗愈功能)',
        logic: '谐音法：乙 (yǐ) ≈ 医 (yī) + 艺 (yì) + 依 (yī)。',
        subItems: [
          { label: '概念', content: '（来自于三奇）希望达成（曲折）、转机' },
          { label: '人物', content: '中医、医生' },
          { label: '植物', content: '中草药 (医药的根本)' },
          { label: '地理', content: '美容院 (广义的疗愈和修复)' },
        ],
      },
    ],
    story: '一位仁慈柔顺的妻子（乙庚合/妻子），她既是一位手法灵巧的艺人（艺术/谐音），也是一位精通中草药（中医/疗愈）的疗愈者。她身处在长满藤蔓与花草（阴木/形态）的花园中，正用柔软的画笔，在一根弯曲的木雕上描绘着一条蜿蜒的龙（动物/攀附），展现出一种曲线救国般的智慧与美感。',
  },
  {
    id: 'bing',
    char: '丙',
    pinyin: 'Bǐng',
    summary: '丙：阳火、权柄、乱子、情人',
    tags: ['丙', '阳火', '权柄', '乱子', '情人'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20250823161106.png',
    coreOrigins: [
      {
        title: '核心原点 ①：阳火 → 希望、光明与热量',
        logic: '太阳之火，人间之光。',
        subItems: [
          { label: '光/概念', content: '希望、光明、雄威、正义、虚荣（渴望如太阳般被瞩目）。' },
          { label: '天时', content: '太阳、晴朗、炎热、夏季、中午。' },
          { label: '地理', content: '厨房、高岭、南方、炉冶、化工厂、煤炭、明亮场所。' },
          { label: '色彩', content: '红色、紫色。' },
          { label: '静物', content: '光亮之物、灯、窗户' },
          { label: '电/静物', content: '电脑、电视、大家电、变压器。（丙加壬，热水器；丙加丙，炉灶）' },
          { label: '其他', content: '电厂、电厂工作者。' },
          { label: '热/静物', content: '灶、发热之物。' },
          { label: '人物', content: '化工工人、司炉工。' },
          { label: '感觉', content: '热、烫、痒。' },
          { label: '人体', content: '浮肿部位、炎症部位、斑点。眼、血液、唇、心脏、小肠。' },
          { label: '形态', content: '少胡须、短发、皮肤白里透红。' },
        ],
      },
      {
        title: '核心原点 ②：乱子 → 刚猛、急速与失控',
        logic: '火性炎上，刚猛急速，易生乱子。',
        subItems: [
          { label: '概念', content: '乱子、刚猛、热烈、急速。' },
          { label: '性情', content: '暴烈、强悍、愤怒、性急、果断。' },
          { label: '人物', content: '脾气暴躁直人、果断刚猛之人。' },
          { label: '爆炸/静物', content: '火箭、大炮。' },
          { label: '动物', content: '马、牛、猪、驴（体型大、能量足、性情刚猛）。' },
        ],
      },
      {
        title: '核心原点 ③：权柄 → 权力、圆融与果实',
        logic: '丙谐音“柄”，握有权柄。形状多为圆。',
        subItems: [
          { label: '权力/概念', content: '权威。' },
          { label: '人物', content: '当权者、有指挥能力。（宫位没有丙，无实权）' },
          { label: '概念', content: '圆状、片状。' },
          { label: '形态', content: '体态丰满、圆脸。' },
          { label: '植物', content: '带柄的果实、梨子、樱桃、西瓜、南瓜、莲蓬、苹果。' },
          { label: '静物', content: '饼干、有柄之物。' },
        ],
      },
      {
        title: '核心原点 ④：三奇 → 情人',
        logic: '情人关系常具有的热烈、激情、光明正大（或渴望光明）。',
        subItems: [
          { label: '人物', content: '情人。' },
        ],
      },
    ],
    story: '一位手握权柄的当权者，在炎热的夏季（阳火）面对一场突发的乱子；正当他脾气暴躁时，他想起了自己的情人曾带给他的希望与热烈，于是拿起一个带柄的苹果（权柄之形），心情平复，恢复了果断与刚猛。',
  },
  {
    id: 'ding',
    char: '丁',
    pinyin: 'Dīng',
    summary: '丁：阴火、钉子、三奇、灯火',
    tags: ['丁', '阴火', '钉子', '三奇'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20250823161232.png',
    coreOrigins: [
      {
        title: '核心原点 ①：阴火 → 光明、热量与智慧',
        logic: '丁是阴火，不同于丙火的太阳之光，它是人间的、内在的、文明的火种，如灯烛、炉火与心中的智慧之光。它温暖、柔和但持久。',
        subItems: [
          { label: '静物', content: '发光体、灯、弱热体、香火、电子产品、烟火、打火机、灶。' },
          { label: '感觉', content: '热、烫。' },
          { label: '人体', content: '眼、心脏、血液。' },
          { label: '人物', content: '眼睛好的人。' },
          { label: '性情', content: '性情柔弱、和顺而有心计、体贴人情、洞察奸邪。' },
          { label: '形态', content: '主人秀丽清高、肤白粉嫩、发细而长（阴火柔美之象）。' },
        ],
      },
      {
        title: '核心原点 ②：钉子 → 尖锐、突出与叮刺',
        logic: '丁的发音（Dīng）与“钉”（Dīng）完全相同，其字形也如同一颗钉子。因此，它代表一切尖锐、突出、带刺或有“叮咬”行为的事物。',
        subItems: [
          { label: '尖锐/概念', content: '尖锐、逼人、带刺、紧盯。' },
          { label: '人体', content: '牙、骨刺、肉刺、男性生殖器。' },
          { label: '静物', content: '刀、针、剑、注射器、钉子、牙签、拐杖、炮弹、子弹、小型金属物件、首饰。' },
          { label: '形态', content: '额宽颏尖（丁字脸）。' },
          { label: '突出/概念', content: '顶尖、突出。' },
          { label: '人物', content: '技术一流之人、表现突出之人、歌星。' },
          { label: '地理', content: '路口（丁字路口）、房檐、屋角、房顶、塔、高岗。' },
          { label: '叮刺/人物', content: '说话带刺之人' },
          { label: '动物', content: '叮咬人和动物的昆虫（蚊子、跳蚤、马蜂、蜜蜂、牛虻）、带刺的动物（刺猬、野猪、蛇）。' },
          { label: '植物', content: '带刺的植物或果实（玫瑰、月季、槐树、仙人掌、松树、石榴、板栗、毛丹、枣树、榛子）。' },
          { label: '订正/静物', content: '票据、文章、证件、证书、合同。' },
        ],
      },
      {
        title: '核心原点 ③：三奇 → 希望、情人',
        logic: '丁是“天上三奇”（乙、丙、丁）之一，代表奇迹、机遇和希望。在人际关系上，它特指情人',
        subItems: [
          { label: '概念', content: '希望、执著、发展。' },
          { label: '人物', content: '情人、妓女。' },
        ],
      },
    ],
    story: '在一个路口（钉子之形）旁，一位技术顶尖的珠宝匠人，在灯（阴火）下，用一根尖锐的针（钉子）为他的情人（三奇）雕刻一件首饰，这件作品寄托着他对未来的希望，不料手指被刺了一下，就像被蚊子叮咬一般。',
  },
  {
    id: 'wu',
    char: '戊',
    pinyin: 'Wù',
    summary: '戊：阳土、大肉、憨厚、钱',
    tags: ['戊', '阳土', '大肉', '憨厚', '钱'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20250823161644.png',
    coreOrigins: [
      {
        title: '核心原点 ①：阳土（山） → 广阔、坚固、承载',
        logic: '戊是阳土，代表广阔、坚固、静止的大地、山峦与城墙。它引申为一切由土构建的、具有承载和保护功能的场所与物品。',
        subItems: [
          { label: '五行', content: '阳土。' },
          { label: '概念', content: '中正、厚德载物、包容。' },
          { label: '地理', content: '庭院、起居室、客厅、墙壁、水泥横梁、堤防、坟地、陵园、土地、水泥厂等。' },
          { label: '静物', content: '陶制品、土制品、瓷碗、瓷杯、瓷勺、瓷盆、瓷缸、砖瓦、水泥制品等。' },
          { label: '人体', content: '胃、脾、腹部（中医里土主运化，对应中焦脾胃）。' },
          { label: '感觉', content: '沉重。' },
          { label: '中介', content: '中介人、矿山开采者。地理：中介所、顾问机构。' },
          { label: '人物', content: '妓男（注解：作为满足他人需求的物理“载体”或服务“平台”，带有交易属性，故归于此）。' },
        ],
      },
      {
        title: '核心原点 ②：大肉 → 敦实、丰满、方正',
        logic: '戊土厚重广博，其形态表现为敦实、丰满、方正、肉多。此象意延伸至体型庞大敦厚的动物，以及叶片宽大或果实肉质的植物。',
        subItems: [
          { label: '形态', content: '形体敦厚、四方脸、肤黄白、身体多肉。' },
          { label: '人体', content: '鼻、胸、乳房、臀部（身体丰满肉多的部位）。' },
          { label: '动物', content: '牛、猪、骆驼、狗熊、企鹅、熊猫等（皆为体型敦厚、行动显沉稳的动物）。' },
          { label: '植物', content: '叶子宽厚方大或土生的肉质多的果实（如芭蕉、向日葵、杨树、南瓜、倭瓜、白薯、土豆、山药、萝卜等）。' },
        ],
      },
      {
        title: '核心原点 ③：憨厚 → 忠厚、守信、愚笨',
        logic: '戊土的性情如大地般忠厚、守信，但也因其固重不变，而有愚笨、迟缓甚至刚烈暴躁的一面（山之不可移，一旦爆发则如山崩）。',
        subItems: [
          { label: '性情', content: '正：守信、忠诚、直方大。 \n负：憨厚、愚笨、痴呆、行动迟缓、刚烈暴躁（土的固执与爆发）。' },
          { label: '人物', content: '正：从农者、德高望众之人、宽厚中庸之人。 \n负：果敢豪杰（山岳般稳重果决）、固执之人。' },
        ],
      },
      {
        title: '核心原点 ④：金钱 → 资本、钱财、金融',
        logic: '土生金，有地就是有钱',
        subItems: [
          { label: '概念', content: '资本、钱财、金融。' },
          { label: '人物', content: '会计、金融机构、出纳、银行职员、地产商。' },
        ],
      },
    ],
    story: '一位身材胖大、性格憨厚的地产商（平台），站在他亲手建造的庭院（阳土）里，他像一只敦实的熊猫一样，虽然有时行动略显迟缓，但做生意极其守信，因此他的金融事业做得风生水起。',
  },
  {
    id: 'ji',
    char: '己',
    pinyin: 'Jǐ',
    summary: '己：阴土、坑、弯曲、策划',
    tags: ['己', '阴土', '坑', '弯曲', '策划'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20250823161815.png',
    coreOrigins: [
      {
        title: '核心原点 ①：阴土（坑） → 低洼、垃圾、污秽',
        logic: '己是阴性的、湿润的、肥沃的田园之土。戊是山，己是坑。它代表着低洼、垃圾，同时也与消化、排泄后的污秽之所相关联。',
        subItems: [
          { label: '地理', content: '坑、沟、厕、下水道、垃圾、湿地、坟地、墓场、田园、低洼地、明堂、阳台、肮脏污秽之物。' },
          { label: '静物', content: '土制泥制陶制工艺品、食物、垃圾、大便等。' },
          { label: '人体', content: '嘴（入口）、脐、肛门（出口）、脾、肠、疤。 (己+壬，己+癸：拉稀)' },
          { label: '感觉', content: '沉重。' },
        ],
      },
      {
        title: '核心原点 ②：弯曲 → 卷缩',
        logic: '己的字形和象意都充满了“弯曲”和“卷缩”的形态，如同盘旋的绳索或休眠的动物。它引申为一切物理上或行为上不直接、不伸展的状态。',
        subItems: [
          { label: '形态', content: '形体单薄，瘦弱丑陋（有蜷缩、不舒展之感）、圆脸。' },
          { label: '人物', content: '打坐的人、身体屈尊的人、握手抱拳之人（身体姿态的弯曲）。' },
          { label: '动物', content: '蜗牛、章鱼、墨鱼、卷曲身子的动物、身体过度弯曲的动物、休眠的动物（如蛇、熊、猫狗等）。' },
          { label: '植物', content: '卷曲没有展开的植物、含苞待放的花蕾（如圆白菜、菊花、含羞草、植物的芽）。' },
          { label: '静物', content: '绳索、线团、毛巾。（己加丁，毛巾覆盖钥匙）' },
          { label: '概念', content: '拐弯抹角、杂乱（线团般杂乱）。' },
        ],
      },
      {
        title: '核心原点 ③：策划 → 欲望、心计',
        logic: '由“弯曲”的物理形态，引申出思维上的“花花肠子”/己象大脑，引申为策划。这种内在的、复杂的、不为人知的心理活动，表现为周密的计划、细腻的思考，也包括欲望和邪念。',
        subItems: [
          { label: '概念', content: '策划、欲望、邪念、创意、花花肠子、节约、吝啬（旧物导致吝啬）、有主意、想法多、忌讳多、思考问题细心。' },
          { label: '人物', content: '诸葛亮式的人物、策划人、广告人、妓女（与欲望和心计相关）、爱吃零食的人（被欲望驱动）。' },
          { label: '性情', content: '忧愁之相、声音含糊重浊（心事重重）、静多动少、温顺沉静（内心活动丰富）。' },
        ],
      },
    ],
    story: '一位心思缜密的策划人（策划），身体弯曲地蹲在自家坟墓（阴土）的沟渠旁，他看着地上卷曲的绳索和爬行的蜗牛，有很多坑和垃圾，脑中那些如“花花肠子”般复杂的创意，就像旁边的菊花花蕾，正含苞待放。',
  },
  {
    id: 'geng',
    char: '庚',
    pinyin: 'Gēng',
    summary: '庚：阳金、武器、阻碍、凶狠',
    tags: ['庚', '阳金', '武器', '阻碍', '凶狠'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20250823162010.png',
    coreOrigins: [
      {
        title: '核心原点 ①：阳金 → 坚硬的物质实体',
        logic: '《说文解字》："位西方，象秋时万物庚庚有实也。"秋天果实结实坚硬的感觉。本身的形状象戈加盾，为武器、征战之意。《释名・释天》庚，坚强貌也。庚是阳金，是世间一切坚硬、刚强的物质基础，从自然界的矿石到人造的金属器械，再到人与动植物的支撑骨架，都属于庚金的范畴。',
        subItems: [
          { label: '金属与矿石', content: '静物：石头、石制品、石兽、门窗、骨类、刀枪器械、汽车、金属制品。地理：道路、钢铁厂、矿山机械。' },
          { label: '身体与形态', content: '人体：头骨、骨骼、肺、大肠、皮毛、肩背。形态：形体瘦长、骨格健壮、长脸白皮肤、筋强骨健、秃头。' },
          { label: '植物', content: '植物的干、根、果壳等。' },
        ],
      },
      {
        title: '核心原点 ②：凶猛 → 肃杀的对立与冲突',
        logic: '庚在奇门遁甲等术数中常作为“值符”的对立面，是天生的“反派”角色，代表着阻碍、关卡与变革前的破坏力。它是一切冲突、斗争与凶险事物的总代表。',
        subItems: [
          { label: '阻碍', content: '概念：阻碍、阻隔、斗打、肃杀、凶恶、野蛮、压力。感觉：疼痛。' },
          { label: '执行者', content: '人物：军警、黑社会、凶残之人、武断之人。（应象：义士秃头大金链子大手表应了牢狱之象、庚+壬缓解压力）。动物：凶恶的动物、老虎、狼、狮子、豹子、毒蛇、生物病毒等。' },
          { label: '冲突场所', content: '地理：关卡、收费站、牢狱、大路。（庚+杜门：牢狱之象）' },
        ],
      },
      {
        title: '核心原点 ③：技术 → 刚健的魄力与能力',
        logic: '庚金的坚硬特质，也引申为一个人安身立命的“硬本领”和坚忍不拔的意志力。它代表着千锤百炼后形成的过硬技术和刚健魄力。',
        subItems: [
          { label: '能力与品质', content: '概念：魄力、气概、刚健、技术过硬。性格：刚健敏锐、坚忍不拔、威严残暴、性刚质硬。' },
          { label: '拥有者', content: '人物：武术、本领高强之人。' },
        ],
      },
    ],
    story: '在一条崎岖的道路（阳金）上，黑社会（凶恶）设置了关卡进行阻碍，一位本领高强的军警（技术）驾驶着汽车（阳金），凭借过硬的技术与刚健的魄力，突破重围，拿着刀枪武器，与敌人展开激烈斗打。',
  },
  {
    id: 'xin',
    char: '辛',
    pinyin: 'Xīn',
    summary: '辛：阴金、首饰、错误、变革',
    tags: ['辛', '阴金', '错误', '变革'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20250823162147.png',
    coreOrigins: [
      {
        title: '核心原点 ①：阴金 → 珠宝、晶体与贵重品',
        logic: '辛是阴性的、被加工过的、小巧精致的金属。它代表一切小型的、贵重的、颗粒状的物品，如同珠宝、首饰和粮食，是财富与秀气的象征。',
        subItems: [
          { label: '贵重物品', content: '小型的金属物品、饰品、艺术品、戒指、项链、手镯、小摆件、钥匙、螺丝、佛珠、手表、金银珠宝、小刀、贵重物品、金钱、印章、保险柜、工程塑料等小型制品。' },
          { label: '颗粒与花果', content: '颗粒状粮食（如：大豆、高粱、玉米）、小型花朵（如：茉莉、米兰）、花果、动物的卵或胎坯。' },
          { label: '形态与性情', content: '修长方正、皮肤白嫩、长脸凹腮；忠诚爽柔、温润秀气、自尊但虚荣、意志稍不坚。' },
          { label: '相关地理/天时', content: '五金加工厂、手表厂、首饰厂、工艺品厂、门窗、道路、石块、水泥；星星、秋天、傍晚、西方；白色、粉色。' },
        ],
      },
      {
        title: '核心原点 ②：错误 → 问题、病灶与罪错',
        logic: '《说文解字》：“辛，大罪也。”十干中属于狱神。它代表着概念上的错误、法律上的罪错，以及身体上令人疼痛的微小病灶。',
        subItems: [
          { label: '概念与感觉', content: '错误、问题；疼痛。（戴手表可以规避错误）' },
          { label: '人物', content: '罪人、犯法者。' },
          { label: '人体病灶', content: '牙、骨（特指骨刺等病变）、肺、皮毛、疙瘩、瘤、骨刺、湿疹、粉刺、痘。' },
          { label: '微小侵害', content: '寄在人或动物身上的生物或病毒、直径不超过一厘米的虫类。' },
          { label: '终结之象', content: '骸骨、尸体（生命的终结，可视为最终的“错误”或“问题”状态）。' },
        ],
      },
      {
        title: '核心原点 ③：变革 → 创新、革命与更新',
        logic: '《史记・律书》："辛者，言万物之新生。" 发现“错误”是“变革”的开。辛金代表了修正错误、推陈出新的强大动力。这种力量可以是颠覆性的叛逆与革命，也可以是温和的创新与自我更新。',
        subItems: [
          { label: '概念', content: '叛逆、创新、变革、更新、变化。' },
          { label: '人物', content: '革命者、改革之人、宗教徒（注解：寻求自我革新与灵魂净化的人）。' },
          { label: '天时', content: '雷电（注解：大自然中突如其来的变革与能量释放）。' },
        ],
      },
    ],
    story: '一位戴着金银珠宝（阴金）的革命者（变革），发现自己被同伴出卖，而被罪犯包围，这是一个致命的错误（错误）；他像被骨刺扎了一样感到疼痛，但当他看到窗外闪烁的星星时，他下定决心要进行一场彻底的创新。',
  },
  {
    id: 'ren',
    char: '壬',
    pinyin: 'Rén',
    summary: '壬：阳水、大海、流动、智慧',
    tags: ['壬', '阳水', '妊', '智慧', '迷茫'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20250823162543.png',
    coreOrigins: [
      {
        title: '核心原点 ①：阳水 → 流动、迁移与变化',
        logic: '壬是阳性的大水，如江河奔腾，其最根本的特性就是永不停息的流动。这引申出一切与宏大移动、交通、变迁相关的人、事、物。',
        subItems: [
          { label: '概念', content: '流动、迁移、变化。' },
          { label: '人物', content: '旅游者、航海者、海员、渔猎者。' },
          { label: '地理', content: '江、河、湖、海、道路、人流、车站、码头、机场、电影院、娱乐场所、礼堂、会堂、饭店。' },
          { label: '静物', content: '纯净水、水池、自来水、洗手间、厨房、水管、水线等、消防用品。 被子、窗帘、灯罩（流动）。' },
          { label: '人体', content: '动脉（血液的流动）、小腿（支撑人体的流动）。' },
          { label: '形态', content: '走路摇摆、 皮肤稍黑、大眼睛、双眼皮、长发秀眉。' },
          { label: '动植物', content: '水中物、鱼、虾、蟹、龟等；荷花、菱角、海带、海草等。' },
          { label: '颜色', content: '蓝色、黑色。' },
        ],
      },
      {
        title: '核心原点 ②：壬 (rén) ≈ 妊 (rèn) → 孕育、生产与包容',
        logic: '壬的发音与“妊”（怀孕）相近，《说文解字》。对 "壬" 的解释是：”象人褢妊之形”。它代表着包容、蕴藏、生产，是生命与新事物的温床。',
        subItems: [
          { label: '概念', content: '孕育、蕴藏、生产。' },
          { label: '人物', content: '孕妇、水产者、养殖者。' },
          { label: '人体', content: '膀胱、宫胞（注解：均为容纳、孕育的器官）。' },
          { label: '性情', content: '容纳。' },
        ],
      },
      {
        title: '核心原点 ③：智慧 → 思想、谋略与柔顺',
        logic: '正：“上善若水”，水深则静，静则生慧。甲骨文的壬跟工很像，能工巧匠自然聪慧。 \n负：迷茫，源于大水无边无际、深不可测的形象，使人迷失方向，陷入困境。',
        subItems: [
          { label: '概念', content: '正：智慧。 \n负：迷茫、困境、纵欲。' },
          { label: '性情', content: '正：柔顺、勇敢、多智、热情、威严。 \n负：阴险、纵欲、任性。' },
          { label: '人体', content: '发（肾之华，肾主智）、眼（智慧之窗）、心脏（心主神明）。' },
          { label: '人物', content: '负：风流、流氓（欲望泛滥，迷失自我）。' },
          { label: '地理', content: '负：监狱（禁锢流动的地方）。' },
          { label: '感觉', content: '负：胀痛（被充满、无法疏导）。' },
        ],
      },
    ],
    story: '一位充满智慧皮肤稍黑（水色）、大眼睛、双眼皮、长发秀眉的孕妇（妊），为了寻求新生活，决定乘船跨越大海（阳水/流动）；然而，突起的大雾让她在无边水域中陷入了迷茫的困境，这考验着她内在的勇气与智慧。',
  },
  {
    id: 'gui',
    char: '癸',
    pinyin: 'Guǐ',
    summary: '癸：阴水、性、困境、井泉',
    tags: ['癸', '阴水', '性', '困境'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20250915184503.png',
    coreOrigins: [
      {
        title: '核心原点 ①：阴水 → 渗透、滋润、微小流动',
        logic: '癸是阴性的水，如雨露、溪流、津液，其特性是渗透、滋润、持续但微小的流动。它是一切喜水生命的源泉，也代表着生活中的各类液体。',
        subItems: [
          { label: '概念', content: '流动、变动、变化、聪明。' },
          { label: '人物', content: '瓜农、菜农、茶农（需要阴水灌溉的职业）。' },
          { label: '动物', content: '水鸟、鸭、鹅、雁、鹤、鹬、鹭（生活在湿地池塘的动物）。' },
          { label: '植物', content: '水稻、蔬菜、水果、水仙、喜水植物。' },
          { label: '静物', content: '小水、酒、醋、盐、茶、饮品、油漆、汤、液体物品、水具。' },
          { label: '地理', content: '湿地、池塘、水塔、地下水。' },
          { label: '感觉', content: '麻凉（雨水的触感）。' },
        ],
      },
      {
        title: '核心原点 ②：性 → 隐秘、欲望、精元',
        logic: '癸水对应人体最阴私的体液和器官，是生命的根本精元，也由此引申出与性、欲望相关的隐秘之事。《说文》：”癸承壬，象人足。“',
        subItems: [
          { label: '概念', content: '性、淫。' },
          { label: '人物', content: '淫荡之人。' },
          { label: '人体', content: '足（身体最下方，属阴）、私处（女性）、静脉（相对于动脉为阴）、肾脏（水脏）、眼球、精液、痣、口水、眼泪、鼻涕、汗液、尿溺（注解：几乎囊括了人体所有体液）。' },
          { label: '地理', content: '淫秽场所。' },
        ],
      },
      {
        title: '核心原点 ③：困难 → 制约、管束、艰难困苦',
        logic: '癸水也是被困住的水，如井水、地沟水、牢狱中的污水，象征着被限制、被管束的艰难困苦。这种状态下的人，往往显得弱小、无助。',
        subItems: [
          { label: '概念', content: '困难、诡计、制约、管束、艰难困苦、跋涉。' },
          { label: '人物', content: '囚犯、被困之人、穷困潦倒之人；酒鬼（被嗜好所困之人）。' },
          { label: '形态', content: '矮小黑丑、圆脸瘦肩、声调不高（受压抑的外在形象）。' },
          { label: '性情', content: '阴柔怕事、多愁善感、不能自主。' },
          { label: '静物', content: '鞋（用于艰难跋涉）。' },
          { label: '动物', content: '黑蝇（注解：常与污秽、停滞的环境相关）。' },
          { label: '地理', content: '地沟、地井、污水、粪池。' },
        ],
      },
    ],
    story: '一个穷困潦倒的人（网罗之水/困境），在阴雨连绵的湿地（阴水）艰难跋涉，他因饥渴而流下口水（精血之源），最终发现了一片由地沟水灌溉的蔬菜地，这片土地成了他摆脱制约、获得新生的希望。',
  },
];